<template>
  <div>
    <top-img-temp :imgUrl="topImg" :cName="cName" :e-name="eName"></top-img-temp>
    <div class="section2">
      <div class="cont">
        <div v-for="(item,index) in filelist"
             class="innerCon"
             @click="downLoadFile(item.value)"
             :key="index">
          <div class="left">
            <span class="fangkuai"></span>
            <!-- <span>{{item.key}}</span> -->
            <span>{{isChinese ? item.key : item.keyEn}}</span>
          </div>
          <div class="right">
            {{item.date}}
          </div>
        </div>

        <div class="fenye">
          <el-pagination @size-change="sizeChangeHandle"
                         @current-change="currentChangeHandle"
                         :current-page="pageIndex"
                         :page-size="pageSize"
                         :total="totalPage"
                         layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>

      </div>

    </div>
  </div>
</template>

<script>

  import topImgTemp from './baseTemp/topImgTemp'
  export default {
    name: "contactUs",
    data() {
      return {
        isChinese: undefined,
        topImg: require('../../static/images/base/XZZX-40.jpg'),
        cName: '下载中心',
        eName: 'DownLoad',
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        filelist: []
      }
    },
    computed: {
      setCAE() {
        return this.$store.state.cAeSatus
      }
    },
    watch:{
      // $route( to , from ){
      //   this.isChinese = localStorage.getItem('setCEcontrol') === '1' ? true : false
      // },
      setCAE(newVal) {
        this.isChinese = newVal === 1 ? true : false
      },
    },
    components: {topImgTemp},
    created() {
      this.getFilesList()
      this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;
    },
    methods: {
      getFilesList() {
        this.$http
          .get("/jishi/api/files/list", {
            params: {
              type: 0,
              page: this.pageIndex,
              limit: this.pageSize
            }
          })
          .then(
            function (res) {
              console.log(res)
              if (res && res.data.code === 0) {
                let resdata = res.data.page
                this.filelist = resdata.list
                this.totalPage = resdata.totalCount
              }
            }.bind(this)
          )
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getFilesList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getFilesList()
      },
      downLoadFile (fileUrl) {
        window.open(fileUrl, "_blank");
      }
    }
  }
</script>

<style scoped>
  .section2 {
    padding: 40px 0 ;
  }
  .innerCon {
    width: 70%;
    margin: 0 auto;
    display: flex;
    padding: 10px 5px;
    margin-top: 20px;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
  }

  .innerCon:hover{
    box-shadow: 2px 2px 5px #dddddd;
  }
  .fangkuai{
    display: inline-block;
    width: 9px;
    height: 9px;
    background: #F7B100;
  }
  .left {
    font-size:1.5rem;
    color: #9b9696;
  }
  .left span:nth-child(2) {
    margin-left: 10px;
  }
  .right {
      font-size:1.5rem;
    }
  @media screen and (max-width:900px){
    .innerCon {
      display: block;
      width: 95%;
    }
    .right {
      font-size:1.5rem;
      margin-top: 10px;
    }

  }
  .fenye {
    margin: 20px 0 ;
    height: 40px;
    display: flex;
    justify-content: center;
  }

  .fenye >>> .el-icon-arrow-left:before, .fenye >>> .el-icon-arrow-right:before{
    display: block;
  }
  .fenye >>> .el-icon-arrow-right:before{
    display: block
  }
  .fenye >>> .el-pagination button {
    width: auto;
  }
  .fenye >>> .el-pager  {
    width: auto;
  }


</style>



// WEBPACK FOOTER //
// src/components/downLoadCenter.vue